module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"duplicateWarning":"Impact is already added.  You can add multiple solutions to this impact."},"de":{"duplicateWarning":"Wirkung wurde bereits hinzugefügt.  Sie können mehrere Lösungen zu dieser Wirkung hinzufügen."}}')
  delete Component.options._Ctor
}
